import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import '../../styles/modal/CoreModal.css';
import '../../styles/salesPopup/SalesPopup.css';

const SalesPopupSuccessModal = ({ onClose }) => {
  const coreApp = document.getElementById('core-app');

  if (!coreApp) {
    return null;
  }
  
  return ReactDOM.createPortal(
    <div className="core__modal" onClick={onClose}>
      <div className="core__modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="core__modal-header">
          <h2>Thank You!</h2>
          <button className="core__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="core__modal-body">
          <div className="sales-popup-success__icon-wrapper">
            <FontAwesomeIcon icon={faCheckCircle} className="sales-popup-success__icon" />
          </div>
          <h3 className="sales-popup-success__title">Your request has been received!</h3>
          <p className="sales-popup-success__text">
            Our team will contact you shortly to help you claim your discount.
          </p>
        </div>
      </div>
    </div>,
    coreApp
  );
};

export default SalesPopupSuccessModal;

